import React, {useEffect} from "react";
import {Button} from "primereact/button";
import {Helmet} from "react-helmet-async";
import LinkComponent from './../../shared/components/LinkComponent';
import Logo from "../../shared/components/Logo";
import {useState} from 'react';

import "./Homepage.scss";
import "../../../styles/TablePricing.scss";

import blockImg1 from "../../../assets/img/undraw_survey_05s5.svg";
import blockImg2 from "../../../assets/img/undraw_team_page_re_cffb.svg";
import blockImg3 from "../../../assets/img/undraw_real_time_analytics_re_yliv.svg";
import blockImg4 from "../../../assets/img/undraw_team_re_0bfe.svg";
import facebook from "../../../assets/img/facebook.svg";
import instagram from "../../../assets/img/instagram.png";
import linkedin from "../../../assets/img/linkedin.png";
import banner from "../../../assets/img/campaign-creators-gMsnXqILjp4-unsplash.jpg";
import slider1 from "../../../assets/img/slider1.png";
import slider2 from "../../../assets/img/slider2.png";
import slider3 from "../../../assets/img/slider3.png";
import slider4 from "../../../assets/img/slider4.png";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Language from "../../shared/components/Language";
import TablePricing from "../../shared/components/TablePricing";


export default function Homepage() {


    const [isActive, setIsActive] = useState(false);
    const { t } = useTranslation();


    const handleClick = event => {
        setIsActive(current => !current);
    };

    const burger = document.getElementsByClassName('burguer');
    const menuItemsResponsive = document.getElementsByClassName('responsive');

    window.addEventListener('resize', () => {
        if ( burger[0]) {
            burger[0].classList.remove('active');
            menuItemsResponsive[0].classList.remove('active');
        }
    }, false);
    const navigate = useNavigate();

    const onNavigate = () => {
        navigate('/Login');
    }

    return (
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>{t('SEO.HOME.TITLE')}</title>
                <meta name="description" content={t('SEO.HOME.DESCRIPTION')} />
            </Helmet>
       
        <div className="home">
            <div className="header">
                <div className="header__container">
                    <Logo/>
                    <div className="menu">
                        <div className="menu__container">
                            <nav className="primary">
                                <Language />
                                <LinkComponent text={t('HOME.MAIN.FEATURE')} href="#features"/>
                                <LinkComponent text={t('HOME.MAIN.PRICING')} href="#pricing"/>
                                <LinkComponent text={t('HOME.MAIN.ABOUT_US')} href="#about"/>
                                <LinkComponent text={t('HOME.MAIN.CONTACT')} href="#contact"/>
                            </nav>
                            <div className={"burguer " + (isActive ? 'active' : '')} onClick={handleClick}>

                                <span className="line line1"></span>
                                <span className="line line2"></span>
                                <span className="line line3"></span>
                            </div>
                            <nav className={"responsive " + (isActive ? 'active' : '')}>
                                <div className="items">
                                    <LinkComponent text={t('HOME.MAIN.FEATURE')} href="#features"/>
                                    <LinkComponent text={t('HOME.MAIN.PRICING')} href="#pricing"/>
                                    <LinkComponent text={t('HOME.MAIN.ABOUT_US')} href="#about"/>
                                    <LinkComponent text={t('HOME.MAIN.CONTACT')} href="#contact"/>
                                </div>

                            </nav>
                            <Button label={t('HOME.MAIN.GET_STARTED')} onClick={onNavigate} className="p-button p-button-success"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main">
                <div className="main__container">
                    <section className="top">
                        <h2> {t('HOME.HEADER.TITLE')} <b>{t('HOME.HEADER.BOLD')}</b>
                        </h2>
                    </section>
                    <section className="features" id="features">
                        <div className="block">
                            <div className="block__container">
                                <div style={{alignSelf: "flex-start"}}>
                                    <h4>{t('HOME.FEATURES.ITEM_1.TITLE.LIGHT')} <b>{t('HOME.FEATURES.ITEM_1.TITLE.BOLD')}</b></h4>
                                    <p>{t('HOME.FEATURES.ITEM_1.DESCRIPTION')}</p>
                                </div>
                                <div style={{textAlign: "center"}}>
                                    <img src={blockImg1} alt={t('SEO.HOME.IMG_1')}/>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="block__container reverse">
                                <div>
                                    <img src={blockImg2} alt={t('SEO.HOME.IMG_2')}/>
                                </div>
                                <div>
                                    <h4>{t('HOME.FEATURES.ITEM_2.TITLE.LIGHT')} <b>{t('HOME.FEATURES.ITEM_2.TITLE.BOLD')}</b></h4>
                                    <p>{t('HOME.FEATURES.ITEM_2.DESCRIPTION')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="block__container">
                                <div>
                                    <h4>{t('HOME.FEATURES.ITEM_3.TITLE.LIGHT')} <b>{t('HOME.FEATURES.ITEM_3.TITLE.BOLD')}</b></h4>
                                    <p>{t('HOME.FEATURES.ITEM_3.DESCRIPTION')}</p>
                                </div>
                                <div style={{textAlign: "center"}}>
                                    <img src={blockImg3} alt={t('SEO.HOME.IMG_3')}/>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="block__container reverse">
                                <div>
                                    <img src={blockImg4} alt={t('SEO.HOME.IMG_4')}/>
                                </div>
                                <div>
                                    <h4>{t('HOME.FEATURES.ITEM_4.TITLE.LIGHT')} <b>{t('HOME.FEATURES.ITEM_4.TITLE.BOLD')}</b></h4>
                                    <p>{t('HOME.FEATURES.ITEM_4.DESCRIPTION')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="slider">
                            <div className="slider-item">
                                <img src={slider1} alt="slider 1"/>
                            </div>
                            <div className="slider-item">
                                <img src={slider2} alt="slider 2"/>
                            </div>
                            <div className="slider-item">
                                <img src={slider3} alt="slider 3"/>
                            </div>
                            <div className="slider-item">
                                <img src={slider4} alt="slider 4"/>
                            </div>
                        </div>
                    </section>
                    <section className="pricing" id="pricing">
                        <h3>{t('HOME.PRICING.TITLE')}</h3>
                        <TablePricing isHome={true}/>
                    </section>
                    <section className="banner">
                        <h2>"<b>{t('HOME.LABEL_GRAY.BOLD')}</b> {t('HOME.LABEL_GRAY.LIGHT')}"</h2>
                    </section>
                    <section className="about" id="about">
                        <div className="about__container">
                            <div>
                                <h3>{t('HOME.ABOUT_US.TITLE')}</h3>
                            </div>
                            <div>
                                <p>
                                    {t('HOME.ABOUT_US.DESCRIPTION')}
                                </p>
                            </div>
                        </div>
                    </section>
                    <section className="banner">
                        <img src={banner} alt="banner"/>
                    </section>
                </div>
            </div>
            <div className="footer" id="contact">
                <div className="footer__container">
                    <div>
                        <h3>{t('HOME.CONTACT_TITLE')}</h3>
                    </div>
                    <div>
                        <div>
                            <a href="tel:09733102411">(973) 310 2411</a>
                            <br/><br/>
                            <a href="mailto:Project1@reflectiveresearchgroup.com">Project1@reflectiveresearchgroup.com</a>
                            <br/>
                            <a href="mailto:Info@reflectiveresearchgroup.com">Info@reflectiveresearchgroup.com</a>
                            <br/><br/>
                            <div style={{display: 'flex'}}>
                                <a target="_blank" href="https://www.facebook.com/profile.php?id=100082943871215">
                                    <img src={facebook} alt="facebook"/>
                                </a>
                                <a target="_blank" href="https://www.instagram.com/reflective_research/">
                                    <img src={instagram} alt="instagram"/>
                                </a>
                                <a target="_blank" href="https://www.linkedin.com/in/reflective-research">
                                    <img src={linkedin} alt="linkedin"/>
                                </a>
                            </div>
                            <br/><br/>
                            <p>Copyright © {new Date().getFullYear()}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
} 
